module.exports = __webpack_public_path__ + "static/media/ico-back.c15e9955.svg";